export const UPLOADED_NEW_FILE = 'project/drive/uploaded-new-file';
export const UPLOADING_NEW_FILE = 'project/drive/uploading-new-file';
export const FINISH_UPLOADING_NEW_FILE = 'project/drive/finish-uploading-new-file';
export const SET_UPLOADING_FILE = 'project/drive/set-uploading-new-file';
export const CHANGE_UPLOAD_PROGRESS = 'project/drive/change-uploading-progress';
export const CHANGE_UPLOAD_TIME_LEFT = 'project/drive/change-uploading-time-let';
export const CHANGE_UPLOAD_SPEED = 'project/drive/change-uploading-speed';
export const CHANGED_FOLDER = 'project/drive/changed-folder';
export const FOLDER_CREATED = 'project/drive/folder_created';
export const CURRENT_FOLDER_CHANGED = 'project/drive/current_folder_changed';
export const FOLDER_TREE_ADD = 'project/drive/folder_tree_added';
export const FOLDER_TREE_BACK = 'project/drive/folder_tree_back';
export const LOADING_FILES = 'project/drive/loading_files';
export const LOADED_ALL_FILES = 'project/drive/loaded_all_files';
export const CHANGED_FILE_FOLDER = 'project/drive/changed_file_folder';
export const DRAGGING_DRIVE_ITEM = 'project/drive/dragging_drive_item';
export const FINISH_DRAGGING_ITEM = 'project/drive/finish_dragging_item';
export const ADD_FILES_UPLOAD_QUEUE = 'project/drive/add_files_upload_queue'
export const SHIFT_FILE_UPLOAD_QUEUE = 'project/drive/shift_file_upload_queue'
export const REMOVE_FILE_UPLOAD_QUEUE = 'project/drive/remove_file_upload_queue'
export const SET_TRASH = 'project/drive/set_trash'
export const ADD_FILE_TO_TRASH = 'project/drive/add_file_to_trash'
export const REMOVE_FILE_FROM_TRASH = 'project/drive/remove_file_from_trash'
export const EDIT_FILE_TRASH_LOADING = 'project/drive/edit_trash_item'
export const SET_ALL_TRASH_LOADING = 'project/drive/set_trash_loading'
